export default {
  data() {
    return {
      report: null,
      isLoading: false,
      filter: {
        by: 'partner_name',
        partner: "",
        date: []
      },
    };
  },

  computed: {
    themeStyle(){
      return this.$theme[this.$store.state.theme];
    },

    chartOptions(){
      return {
        columns: ['partner', 'cost'],
        pieHole: 0.4,
        legend: { textStyle: { color: this.themeStyle.COLOR_CONTAINER_TEXT, fontSize: 11 } },
        backgroundColor: 'transparent',
        chartArea: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10
        }
      };
    },

    chartData(){
      if (!this.report) return [];

      let r = this.report.map((item) => {
        return [item.partner_name, parseFloat(item.cost)];
      });

      r.unshift(['Partner', 'Cost']);
      return r;
    },

    master() {
      return this.$store.state.master;
    },

    total(){
      if (!this.report) return {cost: 0, discount: 0};
      let total = {
        cost: 0,
        discount: 0
      };
      
      this.report.forEach((item) => {
        total.cost += parseFloat(item.cost);
        total.discount += parseFloat(item.discount);
      });
      
      return total;
    }
  },

  methods: {
    async loadReport() {
      this.isLoading = true;
      let filter = {
        partner: this.filter.partner,
        by: this.filter.by
      };

      if (this.filter.date && this.filter.date[0]) {
        filter.date_from = this.formatDatePicker(this.filter.date[0]) + ' 00:00:00';
      }

      if (this.filter.date && this.filter.date[1]) {
        filter.date_to = this.formatDatePicker(this.filter.date[1]) + ' 23:59:59';
      }

      let rs = await this.$api.statistic.cost(filter).call();
      
      if (rs.success) {
        this.report = rs.response.result;
      }
      this.isLoading = false;
    },

    formatDatePicker(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return (
        year +
        "-" +
        ("0" + month).slice(-2) +
        "-" +
        ("0" + day).slice(-2)
      );
    },

    onChangeFilter() {
      this.loadReport();
    }
  }
};
